export const REGISTER_STEP_TYPES = {
  DEFAULT: 'default',
  SUCCESS: 'short-reg-success'
};
